import { Box, Button } from "@mui/material";
import { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

interface LogoProps {
  width?: string;
}

export const Logo = ({ width }: LogoProps) => {
  const { t } = useTranslation();
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
      title={t("common:alt.logo")}
    >
      <Box
        component="img"
        sx={{
          width: width ?? "350px"
        }}
        alt={t("common:alt.logo")}
        src="/images/logo.svg"
      />
    </Box>
  );
};

export const ButtonLogo = ({ onClick }: { onClick?: MouseEventHandler<HTMLButtonElement> }) => {
  const { t } = useTranslation();
  return (
    <Button
      sx={{
        paddingX: "8px",
        paddingY: "16px",
        borderRadius: 2,
        "&:hover": { backgroundColor: "inherit" }
      }}
      aria-label={t("common:label.logo")}
      onClick={onClick}
    >
      <Box
        component="img"
        sx={{
          width: "120px"
        }}
        alt={t("common:alt.logo")}
        src="/images/logo.svg"
      />
    </Button>
  );
};
